import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Form,
  Alert,
} from "reactstrap";

//import images
import eirnaLogo from "../assets/images/eirna/eirnabio-connect-logo.png";

import { changeSidebarVisibility } from "../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";


const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectDashboardData = createSelector(
    (state) => state.Layout,
    (state) => ({
      sidebarVisibilitytype: state.sidebarVisibilitytype,
    })
  );

  const { sidebarVisibilitytype } = useSelector(selectDashboardData);

  const [search, setSearch] = useState(false);
  const [currentState, setCurrentState] = useState("");

  const toogleSearch = () => {
    setSearch(!search);
  };

 const handleNavigateButton = (state, link) => {
   setCurrentState(state);
   navigate(link);
 }

  const handleLogout = (e) => {
    e.preventDefault();
    setCurrentState("Logout");
    navigate("/logout");
  };

  const toogleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;
    dispatch(changeSidebarVisibility("show"));

    if (windowSize > 767)
      document.querySelector(".hamburger-icon").classList.toggle("open");

    //For collapse horizontal menu
    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu")
        ? document.body.classList.remove("menu")
        : document.body.classList.add("menu");
    }

    //For collapse vertical and semibox menu
    if (
      sidebarVisibilitytype === "show" &&
      (document.documentElement.getAttribute("data-layout") === "vertical" ||
        document.documentElement.getAttribute("data-layout") === "semibox")
    ) {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
          ? document.documentElement.setAttribute("data-sidebar-size", "")
          : document.documentElement.setAttribute("data-sidebar-size", "sm");
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "lg"
          ? document.documentElement.setAttribute("data-sidebar-size", "sm")
          : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }

    //Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex align-items-center">
              {/* Logo */}
              <div className="navbar-brand-box horizontal-logo me-3">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={eirnaLogo} alt="EIRNABio Connect" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={eirnaLogo} alt="EIRNABio Connect" height="60" />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={eirnaLogo} alt="EIRNABio Connect" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={eirnaLogo} alt="EIRNABio Connect" height="17" />
                  </span>
                </Link>
              </div>

              {/* Hamburger menu */}
              <button
                onClick={toogleMenuBtn}
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
            </div>

            {/* Right side items */}
            <div className="d-flex align-items-center">
              {/* Home button */}
              <button
                onClick={() => handleNavigateButton("Home", "/dashboard")}
                type="button"
                className="btn btn-sm px-3 fs-16 "
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.color = "#33a849";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#6c757d";
                }}
              >
                <i className="ri-home-4-line me-2"></i>
                Home
              </button>
              {/* Help button */}
              <button
                onClick={() => handleNavigateButton("Help", "/help")}
                type="button"
                className="btn btn-sm px-3 fs-16 "
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.color = "#33a849";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#6c757d";
                }}
              >
                <i className="ri-question-line me-2"></i>
                Help
              </button>
              {/* Invite user button */}
              <button
                onClick={() => handleNavigateButton("InviteUser", "/invite-user")}
                type="button"
                className="btn btn-sm px-3 fs-16 "
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.color = "#33a849";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#6c757d";
                }}
              >
                <i className="ri-user-add-line me-2"></i>
                Invite User
              </button>
              {/* Demo data button */}
              <button
                onClick={() => handleNavigateButton("DemoData", "/demo-data")}
                type="button"
                className="btn btn-sm px-3 fs-16 "
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.color = "#33a849";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#6c757d";
                }}
              >
                <i className="ri-database-2-line me-2"></i>
                Demo data
              </button>
              {/* Contact Us button */}
              <button
                onClick={() => handleNavigateButton("ContactUs", "/contact-us")}
                type="button"
                className="btn btn-sm px-3 fs-16 "
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.color = "#33a849";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#6c757d";
                }}
              >
                <i className="ri-customer-service-2-line me-2"></i>
                Contact Us
              </button>
              {/* Updates button */}
              <button
                onClick={() => handleNavigateButton("Updates", "/updates")}
                type="button"
                className="btn btn-sm px-3 fs-16 "
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.color = "#33a849";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#6c757d";
                }}
              >
                <i className="ri-notification-3-line me-2"></i>
                Updates
              </button>
              {/* Settings button - Hidden until settings is overhauled*/}
              {/*
              <button
                onClick={() => handleNavigateButton("Settings", "/settings")}
                type="button"
                className="btn btn-sm px-3 fs-16 "
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.color = "#33a849";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#6c757d";
                }}
              >
                <i className="ri-settings-3-line me-2"></i>
                Settings
              </button>*/}
              {/* Logout Button */}
              <button
                onClick={handleLogout}
                type="button"
                className="btn btn-ghost-secondary btn-sm d-flex fs-16 align-items-center"
                title="Logout"
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#6c757d",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f8f9fa";
                  e.target.style.color = "#dc3545";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#6c757d";
                }}
              >
                <i className="ri-logout-box-line me-2"></i>
                <span className="d-none d-lg-inline">Logout</span>
              </button>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
